import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { isArray } from 'util';
import { environment } from '../../../../environments/environment';
import { MaintenanceTaskInterface } from '../../../dashboard/maintenance/maintenance-task.interface';
import { MaintenanceTaskBuilder } from '../../models/builders/maintenance-task.builder';
import { MaintenanceTaskConfigurationFileBuilder } from './../../models/builders/maintenance-task-configuration-file.builder';

const maintenanceTaskBody = (maintenanceTasks: MaintenanceTaskInterface[]) => {
  return (isArray(maintenanceTasks))
    ? maintenanceTasks.map(maintenanceTask => ({
      hash: maintenanceTask.hash,
      realized: maintenanceTask.checked,
      observation: maintenanceTask.observation
    }))
    : [];
};

const maintenanceTasksBody = (maintenanceTasks: MaintenanceTaskInterface[]) => {
  return {
    maintenanceTasks: maintenanceTaskBody(maintenanceTasks)
  };
};
@Injectable()
export class MaintenanceTaskApiService {

  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${environment.apiUrl}maintenance-tasks`;
  }

  getMaintenanceTaskByModel(
    hash: string,
    year: number
  ) {
    const params = new HttpParams().append('year', year.toString());

    return this.httpClient.get(`${this.apiUrl}/models/${hash}`, { params })
      .pipe(map(MaintenanceTaskBuilder.fromList));
  }

  getMaintenanceTasksOfTheDayByModel(hash: string, day: number) {
    const params = new HttpParams().append('day', day.toString());

    return this.httpClient.get(`${this.apiUrl}/models/${hash}/by-day`, { params })
      .pipe(map(MaintenanceTaskBuilder.fromList));
  }

  updateMaintenanceTasks(maintenanceTasks: MaintenanceTaskInterface[]) {
    return this.httpClient.put(`${this.apiUrl}`, maintenanceTasksBody(maintenanceTasks))
      .pipe(map(MaintenanceTaskBuilder.fromList));
  }

  getMaintenanceTaskFiles(hash) {
    return this.httpClient.get(`${this.apiUrl}/${hash}/files`)
      .pipe(map(MaintenanceTaskConfigurationFileBuilder.fromList));
  }


}




// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/maintenance-task.api.service.ts